import React from 'react';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';
import { ExplorerNode, fileBadgeTone } from 'helper/products/fileExplorer';

import './index.scss';

/** Pasta = ícone; arquivo = etiqueta com a extensão, colorida por família (planilha, PDF, zip…). */
export default function EntryIcon({
  node,
  size = 'md',
}: {
  node: ExplorerNode;
  size?: 'md' | 'lg';
}) {
  if (node.kind === 'folder') {
    return (
      <span className={`file-explorer-entry-icon is-folder is-${size}`} aria-hidden="true">
        <ExplorerIcon name="folder" size={size === 'lg' ? 20 : 16} />
      </span>
    );
  }

  const label = node.extension ? node.extension.slice(0, 4).toUpperCase() : 'ARQ';
  return (
    <span
      className={`file-explorer-entry-icon is-file is-${size} tone-${fileBadgeTone(node.extension)}`}
      aria-hidden="true"
    >
      {label}
    </span>
  );
}
